import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {WhatIsAnimaCloseAction, WhatIsAnimaModalComponent} from '../what-is-anima-modal/what-is-anima-modal.component';

@Component({
  selector: 'app-home-hero-business',
  templateUrl: './home-hero-business.component.html',
  styleUrls: ['./home-hero-business.component.scss']
})
export class HomeHeroBusinessComponent implements OnInit {

  constructor(
      private modalService: NgbModal,
      private router: Router
  ) { }

  ngOnInit(): void {
  }

  openWhatIsModal() {
    const modalRef = this.modalService.open(WhatIsAnimaModalComponent, {
      centered: true,
      windowClass: 'modal what-is-anima bg-transparent',
      backdrop: 'static',
      keyboard: true
    });
    modalRef.componentInstance.data = {};
    modalRef.result.then(
        (res) => {
          if (res === WhatIsAnimaCloseAction.startTest) {
            return this.goToTest();
          }
        }
    );
  }
  async goToTest() {
    return this.router.navigate(
        ['cs']
    );
  }

}
